module.exports = __webpack_public_path__ + "static/media/waves.d994979f.png";